import React from "react";
import { PageHeader, PostItem } from "./../Components";
import get_single_post from "actions/get_single_post";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { baseUrl } from "env";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
  EmailIcon
} from "react-share";
class Comp extends React.PureComponent {
  state = {
    url: "",
    quote: ""
  };
  async componentDidMount() {
    await this.props.get_single_post(this.props.match.params.id);
    this.setState({
      url: window.location.href,
      quote: this.props.item.title
    });
  }
  render = () => (
    <div>
      <PageHeader
        headerClass={
          this.props.item.post_category
            ? this.props.item.post_category.url.split("-").join("_")
            : ""
        }
        pageName={this.props.item.title}
      />
      <div className="container mt80 mb80">
        <PostItem
          thumbnail={`${baseUrl}/api/media/media/${this.props.item.media_id}`}
          id={this.props.item.id}
          content={this.props.item.content}
          content_html={this.props.item.content_html}
          title={this.props.item.title}
        />
        <div className="share_bar">
          <p className="head_line">Paylaş</p>
          <FacebookShareButton url={this.state.url} quote={this.state.quote}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <TwitterShareButton url={this.state.url} quote={this.state.quote}>
            <TwitterIcon size={32} round />
          </TwitterShareButton>
          <LinkedinShareButton url={this.state.url} quote={this.state.quote}>
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
          <EmailShareButton url={this.state.url} quote={this.state.quote}>
            <EmailIcon size={32} round />
          </EmailShareButton>
          <WhatsappShareButton url={this.state.url} quote={this.state.quote}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  item: state.single_post ? state.single_post.data : {}
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      get_single_post
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Comp);
